// extracted by mini-css-extract-plugin
module.exports = {"item":"MultiSelectFacet_item__1gW5a"};